import { Grid } from '@material-ui/core'
import { Box } from '@mui/material'
import styled from 'styled-components/macro'

export const Container = styled(Grid)` 

    .MuiGrid-item {
        padding-top: 2px !important;
    }

    .MuiFormHelperText-root {
        position: inherit !important;
        top: 0 !important;
    }
`
export const CustomTitle = styled.div`
    display: flex;
    align-items: flex-start;
    margin: 18px 8px 18px 8px;
    width: 100%;
    font-weight: 600;
`

export const CustomAlert = styled(Box)`
    display: flex;
    margin: 5px 0px;
    width: 100%;
`
